export { Support as FooterSupport } from './Support';
export { Menu as FooterMenu } from './Menu';
export { Payments as FooterPayments } from './Payments';
export { Warning as FooterWarning } from './Warning';
